var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"configuration-tab"},[_c('PromptsList',{attrs:{"prompts":_vm.visiblePrompts},on:{"answer":_vm.answerPrompt}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }